import { B, type BrandConfig } from "@b/ui";

// The only per-app design surface. Everything else comes from @b/ui.
export const brand: BrandConfig = {
  name: "Set & Ledger",
  slug: "setandledger",
  tint: B.tints.sage,
  logo: "/brand/mark-192.png",
};
